import { BaseModel } from './base.model'
import { Lesson } from './lesson.model'
import { LessonQuizQuestion } from './lesson-quiz-question.model'
import { Question } from './question.model'


export class LessonQuiz extends BaseModel<LessonQuiz> {
  static DEFAULT_ATTRIBUTES = {
    minCorrectAnswers:     0,
    questionsCount:        0,
    questionsLimitEnabled: false,
    shuffleQuestions:      false
  }

  comment: string
  folderId: number
  id: number
  lessonQuizQuestions: LessonQuizQuestion[]
  lessons: Lesson[]
  minCorrectAnswers: number
  name: string
  questionsCount: number
  questionsLimit: number
  questionsLimitEnabled: boolean
  shuffleQuestions: number
  state: string
  timeLimit: number
  questions: Question[]


  removed(): boolean {
    return this.state == 'removed'
  }

  disabled(): boolean {
    return this.state == 'disabled'
  }

  get timeLimitMinutes(): number {
    if(this.timeLimit) {
      return Math.round(this.timeLimit / 60 * 100) / 100
    } else {
      return this.timeLimit
    }
  }

  set timeLimitMinutes(minutes: number) {
    this.timeLimit = minutes ? minutes * 60 : minutes
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/lesson-quiz.model.ts